import {
  UPDATE_JOURNAL_TEMPLATES_LIST,
  TOGGLE_JOURNAL_TEMPLATES_LOADING,
  JOURNAL_TEMPLATES_ERROR,
  JOURNAL_TEMPLATES_UPDATE_TOTAL
} from '../actions/journalTemplatesActions'

const initState = {
  name: 'Journal Templates',
  templates: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0
  }
}

const journalTemplatesReducer = (state = initState, action) => {
  // Immutable nested update: return a NEW `templates` object so useSelector detects the change.
  switch (action.type) {
    case UPDATE_JOURNAL_TEMPLATES_LIST:
      return { ...state, templates: { ...state.templates, list: action.payload.value } }
    case JOURNAL_TEMPLATES_UPDATE_TOTAL:
      return { ...state, templates: { ...state.templates, totalRecords: action.payload.value } }
    case TOGGLE_JOURNAL_TEMPLATES_LOADING:
      return { ...state, templates: { ...state.templates, loading: action.payload.value } }
    case JOURNAL_TEMPLATES_ERROR:
      return { ...state, templates: { ...state.templates, error: action.payload.value } }
    default:
      return state
  }
}

export default journalTemplatesReducer
